import * as React from "react";
import { FormattedMessage } from "../utils/FormattedMessage";
import { Box, Typography, Grid } from "@mui/material";
import { PhoneContact } from "../common/PhoneContact";

function PhoneContactWrapper({ children }: React.PropsWithChildren<{}>) {
  return (
    <Grid
      size={{
        xs: 12,
        lg: 6,
        xl: 4,
      }}
    >
      {children}
    </Grid>
  );
}

function Contacts() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        p: 5,
        backgroundColor: (t) => t.palette.secondary.main,
        color: (t) => t.palette.getContrastText(t.palette.secondary.main),
        alignItems: "center",
        textAlign: "center",
        justifyContent: "center",
        gap: 5,
      }}
    >
      <Typography variant="h3">
        <FormattedMessage id="contacts.contacts.title" />
      </Typography>

      <Grid
        container
        spacing={3}
        sx={{
          justifyContent: "space-evenly",
        }}
      >
        <PhoneContactWrapper>
          <PhoneContact
            phoneID="common.contacts.reference_1.phone"
            description={
              <>
                <b>
                  <FormattedMessage id="common.contacts.reference_1.name" />
                  &nbsp;
                  <FormattedMessage id="common.contacts.reference_1.last_name" />
                </b>
                &nbsp; (
                <FormattedMessage id="common.contacts.reference_1.role" />)
              </>
            }
          />
        </PhoneContactWrapper>

        <PhoneContactWrapper>
          <PhoneContact
            phoneID="common.contacts.reference_2.phone"
            description={
              <>
                <b>
                  <FormattedMessage id="common.contacts.reference_2.name" />
                  &nbsp;
                  <FormattedMessage id="common.contacts.reference_2.last_name" />
                </b>
                &nbsp; (
                <FormattedMessage id="common.contacts.reference_2.role" />)
              </>
            }
          />
        </PhoneContactWrapper>

        <PhoneContactWrapper>
          <PhoneContact
            phoneID="common.contacts.reference_3.phone"
            description={
              <>
                <b>
                  <FormattedMessage id="common.contacts.reference_3.name" />
                  &nbsp;
                  <FormattedMessage id="common.contacts.reference_3.last_name" />
                </b>
                &nbsp; (
                <FormattedMessage id="common.contacts.reference_3.role" />)
              </>
            }
          />
        </PhoneContactWrapper>

      </Grid>
    </Box>
  );
}

export { Contacts };
